'use client';

import { removeJWT } from '@/services/jwt';
import { QueryClient } from '@tanstack/react-query';

export type SignOutOptions = {
  queryClient: QueryClient;
  redirectUrl?: string;
};

export function signOut({
  queryClient,
  redirectUrl = '/volunteer'
}: SignOutOptions) {
  removeJWT();
  queryClient.clear();
  window.location.href = redirectUrl;
}
